import React from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Initiative from './initiatives'
import { BASE_URL_TRASPASO } from '../../../../constants/URLs'

const Content = () => {
  return (
    <section className="tw-mt-2 tw-pt-12 tw-pt-16@lg tw-pb-16 tw-pb-20@lg bg-white">
      <div className={'containerWrap'}>
        <div>
          <div
            className={`tw-pt-2@lg center font-family-primary fw-4 tw-f-18 tw-f-18@lg tw-mb-4`}
          >
            Medio ambiente
          </div>
          <h2 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-6@lg center">
            Gestión responsable con el medio ambiente
          </h2>
          <div className="flex justify-center tw-mb-8 tw-mb-10@lg">
            <p className="w-100 w-60@lg font-family-primary fw-4 tw-f-16 tw-f-16@lg center">
              Prima AFP tiene definido un compromiso con el cuidado del medio
              ambiente, tenemos programas ambientales que ayudan a reducir
              nuestra huella de carbono mediante acciones en las que participan
              nuestros colaboradores. Si haces tu{' '}
              <a
                href={`${BASE_URL_TRASPASO}/`}
                target="_blank"
                className="fw-7 c-orange-0"
              >
                Cambio de AFP online
              </a>{' '}
              podrás aportar a estas iniciativas de responsabilidad social.
            </p>
          </div>
          <Initiative />
        </div>
      </div>
    </section>
  )
}

export default Content
